import type { SettingsType } from "building-types/settings/settingsType";
import type { DocSchemaLibrary } from "schemas-common/docSchema";

export const settingsTypeToSchemaName: { [key in SettingsType]: keyof typeof DocSchemaLibrary } = {
  INTERIOR_MATERIAL_SETTINGS: "InteriorMaterialSettings",
  EXTERIOR_MATERIAL_SETTINGS: "ExteriorMaterialSettings",
  EXTERIOR_PROP_SETTINGS: "ExteriorPropSettings",
  INTERIOR_PROP_SETTINGS: "InteriorPropSettings",
  DOOR_SETTINGS: "DoorSettings",
  WINDOW_SETTINGS: "WindowSettings",
  WINDOW_MATERIAL_SETTINGS: "WindowMaterialSettings",
  ROOF_SETTINGS: "RoofSettings",
  DORMER_SETTINGS: "DormerSettings",
  ROOF_FRAMING_SETTINGS: "RoofFramingSettings",
  WINDOW_FRAMING_SETTINGS: "WindowWallFramingSettings",
  WINDOW_WRAPPING_SETTINGS: "WindowWallWrappingSettings",
  DOOR_FRAMING_SETTINGS: "DoorWallFramingSettings",
  DOOR_WRAPPING_SETTINGS: "DoorWallWrappingSettings",
  PORCH_SETTINGS: "PorchSettings",
  REAR_PORCH_SETTINGS: "RearPorchSettings",
  PLAN_SETTINGS: "PlanSettings",
  MASTER_PLAN_SETTINGS: "MasterPlanSettings",
  SCHEDULE_SETTINGS: "ScheduleSettings",
  KEY_MEASURES_SETTINGS: "KeyMeasuresSettings",
  WAINSCOTING_SETTINGS: "WainscotingSettings",
  WALL_FRAMING_SETTINGS: "WallFramingSettings",
  AWNING_SETTINGS: "AwningSettings",
  FOUNDATION_SETTINGS: "FoundationSettings",
  GARAGE_SETTINGS: "GarageSettings",
  WALL_SETTINGS: "WallSettings",
  WALL_CATALOG_SETTINGS: "WallCatalogSettings",
  EXTERIOR_DOOR_CASING_SETTINGS: "ExteriorDoorCasingSettings",
  INTERIOR_DOOR_CASING_SETTINGS: "InteriorDoorCasingSettings",
  EXTERIOR_WINDOW_CASING_SETTINGS: "ExteriorWindowCasingSettings",
  WINDOW_MULLION_SETTINGS: "WindowMullionSettings",
  WINDOW_SHUTTER_SETTINGS: "WindowShutterSettings",
  EXTERIOR_TRIM_SETTINGS: "ExteriorTrimSettings",
  INTERIOR_TRIM_SETTINGS: "InteriorTrimSettings",
  STRUCTURE_SETTINGS: "StructureSettings",
  ELECTRICAL_SETTINGS: "ElectricalSettings",
  VIEW_NOTE_SETTINGS: "ViewNoteSettings",
  PROFILE_CATALOG_SETTINGS: "ProfileCatalogSettings",
  COLUMN_CATALOG_SETTINGS: "ColumnCatalogSettings",
  DRAWING_CATALOG_SETTINGS: "DrawingCatalogSettings",
  CASEWORK_CATALOG_SETTINGS: "CaseworkCatalogSettings",
  CASEWORK_SETTINGS: "CaseworkSettings",
  DOOR_CATALOG_SETTINGS: "DoorCatalogSettings",
  WINDOW_CATALOG_SETTINGS: "WindowCatalogSettings",
  STAIR_CATALOG_SETTINGS: "StairCatalogSettings",
  RAILING_CATALOG_SETTINGS: "RailingCatalogSettings",
  ELECTRICAL_ITEM_CATALOG_SETTINGS: "ElectricalItemCatalogSettings",
  FLOOR_SETTINGS: "FloorSettings",
  INTERIOR_WINDOW_CASING_SETTINGS: "InteriorWindowCasingSettings",
  HEADER_FRAMING_SETTINGS: "HeaderFramingSettings",
} as const;
